module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAPUExURSgsMEdwTCktMSktMiktMghx7hQAAAAEdFJOUyAA398Dbd8xAAAAbElEQVQY04WQ2wnAIAwAfSyQbiDiAIU6gdl/p8aLoF9tfuQ4yBHDdUz4gnjCA4k9Bu2ekAcmqSnpBZCp8oi+zRQCMIXwTlKEgzTEgq4b8vAWC3qhBdgqWkTnKlRYcZSBN5IC1U+o56Xy8wd7XiD0Fy+/7x3iAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/close.png
// module id = vq1L
// module chunks = 0